<script lang="ts">
import entityPanel from '@nuxtDatakodeUtils/components/i3p/panels/entity-panel.vue'
import EntityHistorique from '~/components/I3pComponent/common/entity/EntityHistorique.vue'
import OpportunityOrganizations from '~/components/I3pComponent/opportunities/entity/OpportunityOrganizations.vue'
import OpportunityComments from '~/components/I3pComponent/opportunities/entity/OpportunityComments.vue'
import OpportunityData = PildomModules.Voirie.Data.OpportunityData
import { useConfigStore } from '~/store'

// noinspection JSUnusedGlobalSymbols
export default {
    name: 'OpportunityEntityPanel',
    components: { OpportunityComments, OpportunityOrganizations, EntityHistorique },
    extends: entityPanel,
    props: {
        currentIntentionK: { type: String, required: false, default: null },
    },
    emits: ['selectIntentionK'],
    computed: {
        opportunityData(): OpportunityData | null {
            return this.entity?.data
        },
    },
    mounted() {
    },
    methods: {
        copyEntityLink() {
            const route = useRoute()
            const configStore = useConfigStore()
            navigator.clipboard.writeText(configStore.currentConfig?.voirie_app_url + route.fullPath)
            this.$showToaster({ text: 'Lien copié', title: '', color: 'info', icon: 'mdi-content-copy' })
        },
        routerPushEntity(k: string | null) {
            if (k) {
                this.$router.push(`${this.baseUrl}/${k}`)
            }
            // this.$router.push(`${this.baseUrl}/creation`) No creation on opportunity
        },
    },
}
</script>

<template>
    <div>
        <div v-if="opportunityData" class="">
            <!-- border-s-md pl-2 border-primary" -->
            <v-row v-if="!i3pService.editMode" class="mb-2">
                <v-col cols="1" class="pr-0">
                    <v-btn
                        icon="mdi-chevron-left" variant="text" size="small" :disabled="!previousKey"
                        aria-label="Précedent"
                        @click="showEntity(previousKey)"
                    />
                </v-col>
                <v-col>
                    <div class="text-h5 text-center">
                        Visualiser une opportunité <span
                            class="text-subtitle-2 pl-2 text-medium-emphasis"
                        >{{ opportunityData.id }}</span>
                    </div>
                </v-col>
                <v-col cols="1" class="pl-0">
                    <v-btn
                        icon="mdi-chevron-right" variant="text" size="small" :disabled="!nextKey"
                        aria-label="Suivant"
                        @click="showEntity(nextKey)"
                    />
                </v-col>
            </v-row>
            <template v-if="entity && opportunityData ">
                <v-btn
                    class="mr-4" variant="text" prepend-icon="mdi-link-variant" size="small" color="primary"
                    @click="copyEntityLink"
                >
                    Copier le lien
                </v-btn>
                <OpportunityOrganizations :opportunity-data :current-intention-k @select-intention-k="$emit('selectIntentionK', $event)" />
                <OpportunityComments :opportunity-data />
                <EntityHistorique :data="opportunityData" :entity />
            </template>
        </div>
        <template v-else>
            <div v-if="dataIsEmpty" class="h-screen">
                <div class="text-h5 text-center">
                    Aucun objet sélectionné
                </div>
            </div>
            <div v-else class="h-screen">
                <v-skeleton-loader type="article" />
                <v-skeleton-loader type="paragraph" />
                <v-skeleton-loader type="paragraph" />
            </div>
        </template>
    </div>
</template>
